import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import BasicModal from "components/common/BasicModal";
import {endDeleteUserDataAction, submitDeleteUserDataAction} from "../../actions";
import {FormattedMessage} from "react-intl";

const ConfirmDeleteUserDataModal = (props) => (
  <BasicModal header={<FormattedMessage id='userManagement.deleteUserData.header'/>}
              specialType={'caution-modal'}
              open={props.open}
              onClose={props.cancel}
              actions={[
                {
                  label: <FormattedMessage id='userManagement.deleteUserData.cancel'/>,
                  action: props.cancel,
                  displayType: "menu-item"
                },
                {
                  label: (
                    <Fragment>
                      <FormattedMessage id='userManagement.deleteUserData.confirm'/>
                    </Fragment>
                  ),
                  loading: props.deleting,
                  action: props.confirm,
                  displayType: "button",
                  primaryCheck: true,
                }
              ]}>
    <h3>
      <FormattedMessage id='userManagement.deleteUserData.confirmMessage'/>
    </h3>
  </BasicModal>
);

const mapState = (state) => {
  return {
    open: state.userManagement.confirmUserDataDeletion
  };
};

const mapDispatch = (dispatch) => {
  return {
    confirm: () => dispatch(submitDeleteUserDataAction()),
    cancel: () => dispatch(endDeleteUserDataAction())
  }
};

const ConfirmDeleteUserDataModalConnected = connect(mapState, mapDispatch)(ConfirmDeleteUserDataModal);

export default ConfirmDeleteUserDataModalConnected;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/ConfirmDeleteUserDataModal.jsx